import { Icon } from '@trlogic/ui-pack';
import React, { Component } from 'react';
import { Tooltip } from 'primereact/tooltip';

class CustomCheckBox extends Component<Props> {
  public render() {
    const { checked, onChangeChecked, hoverText } = this.props;
    return (
      <div
        className={`default-filter ${checked ? 'border-f-purple' : 'border-f-black-5'} ${this.getSize()} shrink-0 rounded-[4px] border-[1px] hover:border-f-purple cursor-pointer`}
        onClick={(e) => {
          onChangeChecked(!checked, e);
        }}
      >
        {hoverText && <Tooltip target='.default-filter'>{hoverText}</Tooltip>}
        {checked && (
          <div className={'flex w-full rounded-[4px] h-full items-center justify-center '}>
            <Icon icon={'check'} className={'text-primary'} size={20} />
          </div>
        )}
      </div>
    );
  }

  private getSize = () => {
    const { size = 'large' } = this.props;
    switch (size) {
      case 'small':
        return 'w-5 h-5';
      case 'large':
        return 'w-6 h-6';
    }
  };
}

interface Props {
  checked: boolean;
  onChangeChecked: (checked: boolean, e?: any) => void;
  hoverText?: string | undefined;
  size?: 'small' | 'large';
}

export default CustomCheckBox;
